<div class="mainHomeContainer">
  <div class="menuContainer">
    <div class="menu">
      <div class="profileContainer">
        @if (user) {
          <ng-lottie class="avatar" [options]="avatarAnimationOptions" [style.background-color]="getBackgroundColorForAvatar()" (error)="onError($event)" />
        }
        <div class="infoContainer">
          <span class="profileEyebrow">{{ 'common.navigation.profile' | translate }}</span>
          <div class="name">{{ profileDisplayName() }}</div>
          <span class="profileRole">{{ accountRoleKey() | translate }}</span>
        </div>
      </div>
      @if (user && (user.first_name || user.last_name || user.pseudo || user.school_name)) {
        <dl class="desktopProfileDetails">
          @if (user.first_name) {
            <div>
              <dt>{{ 'common.labels.firstName' | translate }}</dt>
              <dd>{{ user.first_name }}</dd>
            </div>
          }
          @if (user.last_name) {
            <div>
              <dt>{{ 'common.labels.lastName' | translate }}</dt>
              <dd>{{ user.last_name }}</dd>
            </div>
          }
          @if (user.pseudo) {
            <div>
              <dt>{{ 'common.labels.username' | translate }}</dt>
              <dd>{{ user.pseudo }}</dd>
            </div>
          }
          @if (user.school_name) {
            <div>
              <dt>{{ 'followUp.table.school' | translate }}</dt>
              <dd>{{ user.school_name }}</dd>
            </div>
          }
        </dl>
      }
      <div class="xpAndDaysContainer">
        <div class="desktopProgressCard">
          <div class="desktopLevelSummary">
            <div>
              <span>{{ 'common.labels.currentLevel' | translate }}</span>
              <strong>{{ currentLevel() }}</strong>
            </div>
            <i class="bi bi-arrow-right" aria-hidden="true"></i>
            <div class="nextLevelSummary">
              <span>{{ 'common.labels.nextLevel' | translate }}</span>
              <strong>{{ nextLevel() }}</strong>
            </div>
          </div>
          <div class="desktopXpSummary">
            <div class="desktopXpNumbers">
              <span>XP</span>
              <strong>{{ scores?.global_score ?? 0 }} <small>/ {{ scores?.global_max_score ?? 0 }}</small></strong>
            </div>
            <div
              class="desktopProgressTrack"
              role="progressbar"
              [attr.aria-valuenow]="scores?.global_score ?? 0"
              aria-valuemin="0"
              [attr.aria-valuemax]="scores?.global_max_score ?? 0"
            >
              <div class="desktopProgressValue" [style.width.%]="profileProgressPercentage()"></div>
            </div>
          </div>
        </div>
        @if (shouldDisplayDays() && !shouldDisplayDiploma()) {
          <div class="daysContainer">
            <div class="daysLabel">
              <div class="remainingDays">
                {{ user?.nb_days_left }}
              </div>
              <div class="daysText">
                {{ 'common.labels.days' | translate }}
              </div>
            </div>
            <div class="smallText">
              {{ 'common.messages.completeBedici' | translate }}
            </div>
          </div>
        }
        @if (shouldDisplayDiploma()) {
          <div (click)="openDiplomaModale()" class="diplomaContainer">
            <div class="imgContainer">
              <i class="bi bi-gift-fill"></i>
            </div>
            <div class="text">
              {{ 'common.messages.getReward' | translate }}
            </div>
          </div>
        }
        @if (!isGarUser) {
          <a [routerLink]="[isTP() ? '/helptp' : '/help']" class="helpMenuContainer">
            <img src="/assets/emoji-sad.svg" width="40px" draggable="false" />
            <div class="text">
              {{ 'common.messages.victimHelp' | translate }}
            </div>
          </a>
        }
      </div>
    </div>
  </div>
  <div class="contentContainer">
    <div class="container">
      <div class="row">
        @if (shouldDisplayPremiumOffer) {
          <offer-banner></offer-banner>
        }
        <div class="col-12 col-md-6">
          @for (module of evenModules(); track module) {
            <div class="moduleCard zoomPlusHalo" [ngStyle]="getBackgroundColorForCard(module)">
              @if (isContentLocked(module)) {
                <div class="overlay">
                  <i class="bi bi-lock-fill"></i>
                </div>
              }
              <div class="cardContentContainer">
                <div class="headlineContainer">
                  <div class="moduleImageWrapper">
                    <div class="whiteCircle"></div>
                    <img [src]="getModuleImg(module)" alt="Module" class="image" draggable="false" />
                  </div>
                  <div class="moduleTitle">
                    {{ module.title }}
                  </div>
                </div>
                @if (shouldDisplayMedal(module)) {
                  <div class="bigMedalContainer" [attr.data-module-id]="module.module_enum">
                    <ng-lottie
                      [options]="medalAnimationOptionsForModule(module)"
                      (animationCreated)="onMedalAnimationCreated($event, module)"
                      width="100px"
                      height="100px"
                      (error)="onError($event)"
                    ></ng-lottie>
                  </div>
                }
                <div class="badgesContainer">
                  @for (level of levels; track level) {
                    <div class="badge">
                      <img [src]="getBadge(level, module)" class="imgBadge" draggable="false" />
                    </div>
                  }
                </div>
                <div class="progressbarContainer">
                  <div class="progressbar">
                    <div class="progress" [ngStyle]="progressStyleFor(module)"></div>
                  </div>
                  <span class="progressText">{{ progressFor(module) }} %</span>
                </div>
                @if (shouldDisplayPlayButton(module)) {
                  <div class="playButtonContainer">
                    <div class="playButton ctaBtn" (click)="playModule(module, $event)" [ngStyle]="getColorForCard(module)">
                      {{ 'common.buttons.play' | translate }}
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
        <div class="col-12 col-md-6">
          @for (module of oddModules(); track module) {
            <div class="moduleCard zoomPlusHalo" [ngStyle]="getBackgroundColorForCard(module)">
              @if (isContentLocked(module)) {
                <div class="overlay">
                  <i class="bi bi-lock-fill"></i>
                </div>
              }
              <div class="cardContentContainer">
                <div class="headlineContainer">
                  <div class="moduleImageWrapper">
                    <div class="whiteCircle"></div>
                    <img [src]="getModuleImg(module)" alt="Module" class="image" draggable="false" />
                  </div>
                  <div class="moduleTitle">
                    {{ module.title }}
                  </div>
                </div>
                @if (shouldDisplayMedal(module)) {
                  <div class="bigMedalContainer" [attr.data-module-id]="module.module_enum">
                    <ng-lottie
                      [options]="medalAnimationOptionsForModule(module)"
                      (animationCreated)="onMedalAnimationCreated($event, module)"
                      width="100px"
                      height="100px"
                      (error)="onError($event)"
                    ></ng-lottie>
                  </div>
                }
                <div class="badgesContainer">
                  @for (level of levels; track level) {
                    <div class="badge">
                      <img [src]="getBadge(level, module)" class="imgBadge" draggable="false" />
                    </div>
                  }
                </div>
                <div class="progressbarContainer">
                  <div class="progressbar">
                    <div class="progress" [ngStyle]="progressStyleFor(module)"></div>
                  </div>
                  <span class="progressText">{{ progressFor(module) }} %</span>
                </div>
                @if (shouldDisplayPlayButton(module)) {
                  <div class="playButtonContainer">
                    <div class="playButton ctaBtn" (click)="playModule(module, $event)" [ngStyle]="getColorForCard(module)">
                      {{ 'common.buttons.play' | translate }}
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

@if (user) {
  <button
    type="button"
    class="profileFloatingButton ctaBtn"
    [class.isHidden]="isProfilePanelOpen"
    (click)="openProfilePanel()"
    [attr.aria-label]="'common.navigation.profile' | translate"
    aria-haspopup="dialog"
  >
    <ng-lottie
      class="profileFloatingAvatar"
      [options]="avatarAnimationOptions"
      [style.background-color]="getBackgroundColorForAvatar()"
      (error)="onError($event)"
    />
  </button>
}

@if (isProfilePanelOpen && user) {
  <div class="profilePanelBackdrop" (click)="closeProfilePanel()">
    <section
      class="profilePanel"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="'common.navigation.profile' | translate"
      (click)="$event.stopPropagation()"
    >
      <button type="button" class="profilePanelClose" (click)="closeProfilePanel()" [attr.aria-label]="'common.buttons.close' | translate">
        <i class="bi bi-x-lg" aria-hidden="true"></i>
      </button>

      <div class="profilePanelHeader">
        <ng-lottie
          class="profilePanelAvatar"
          [options]="avatarAnimationOptions"
          [style.background-color]="getBackgroundColorForAvatar()"
          (error)="onError($event)"
        />
        <div class="profilePanelIdentity">
          <span class="profileEyebrow">{{ 'common.navigation.profile' | translate }}</span>
          <h2>{{ profileDisplayName() }}</h2>
          <span class="profileRole">{{ accountRoleKey() | translate }}</span>
        </div>
      </div>

      @if (user.first_name || user.last_name || user.pseudo || user.school_name) {
        <dl class="profileDetails">
          @if (user.first_name) {
            <div>
              <dt>{{ 'common.labels.firstName' | translate }}</dt>
              <dd>{{ user.first_name }}</dd>
            </div>
          }
          @if (user.last_name) {
            <div>
              <dt>{{ 'common.labels.lastName' | translate }}</dt>
              <dd>{{ user.last_name }}</dd>
            </div>
          }
          @if (user.pseudo) {
            <div>
              <dt>{{ 'common.labels.username' | translate }}</dt>
              <dd>{{ user.pseudo }}</dd>
            </div>
          }
          @if (user.school_name) {
            <div>
              <dt>{{ 'followUp.table.school' | translate }}</dt>
              <dd>{{ user.school_name }}</dd>
            </div>
          }
        </dl>
      }

      <div class="profileProgressCard">
        <div class="levelSummary">
          <div>
            <span>{{ 'common.labels.currentLevel' | translate }}</span>
            <strong>{{ currentLevel() }}</strong>
          </div>
          <i class="bi bi-arrow-right" aria-hidden="true"></i>
          <div class="nextLevelSummary">
            <span>{{ 'common.labels.nextLevel' | translate }}</span>
            <strong>{{ nextLevel() }}</strong>
          </div>
        </div>
        <div class="xpSummary">
          <div class="xpNumbers">
            <span>XP</span>
            <strong>{{ scores?.global_score ?? 0 }} <small>/ {{ scores?.global_max_score ?? 0 }}</small></strong>
          </div>
          <div
            class="profileProgressTrack"
            role="progressbar"
            [attr.aria-valuenow]="scores?.global_score ?? 0"
            aria-valuemin="0"
            [attr.aria-valuemax]="scores?.global_max_score ?? 0"
          >
            <div class="profileProgressValue" [style.width.%]="profileProgressPercentage()"></div>
          </div>
        </div>
      </div>

      @if (shouldDisplayDays() && !shouldDisplayDiploma()) {
        <div class="profileDays">
          <strong>{{ user.nb_days_left }}</strong>
          <span>{{ 'common.labels.days' | translate }} {{ 'common.messages.completeBedici' | translate }}</span>
        </div>
      }
      @if (shouldDisplayDiploma()) {
        <button type="button" (click)="openDiplomaModale()" class="profileRewardButton">
          <i class="bi bi-gift-fill" aria-hidden="true"></i>
          {{ 'homeChild.getMyRewardButton' | translate }}
        </button>
      }
      @if (!isGarUser) {
        <a [routerLink]="[isTP() ? '/helptp' : '/help']" class="profileHelpCta" (click)="closeProfilePanel()">
          <img src="/assets/emoji-sad.svg" width="36" height="36" draggable="false" alt="" />
          <span>{{ 'common.messages.victimHelp' | translate }}</span>
          <i class="bi bi-arrow-right" aria-hidden="true"></i>
        </a>
      }
    </section>
  </div>
}
